<div class="modal-header">
  <h4 class="modal-title">Select A City</h4>
  <aurora-icon-button class="close" type="button" (click)="cancelSelection()" icon="times" size="large"></aurora-icon-button>
</div>
<div class="modal-body" style="font-size: 14px">
  <table class="table table-select table-fixed-header">
    <tr>
      <th>Preferred City</th>
      <th>City</th>
      <th>County</th>
      <th>State</th>
    </tr>
    <tr *ngFor="let option of options; index as i" (click)="app.getSelectedText() && onSelect(option)">
      <td>
        <span *ngIf="i === 0">Yes</span>
      </td>
      <td>
        {{ option }}
      </td>
      <td>{{ county }}</td>
      <td>{{ state }}</td>
    </tr>
  </table>
</div>
<div class="modal-footer">
  <aurora-button type="button" (click)="cancelSelection()" variant="primary">Cancel</aurora-button>
</div>
